/*
 * Copyright (c) 2023
 *
 * The source code and all documents related to the source code ("Material") are owned by
 * Frictionless Systems, LLC.
 *
 * The Material contains trade secrets, proprietary information, and confidential information.
 * No part of the Material may be used, copied, reproduced, modified, published, distributed, or
 * disclosed in any way without Frictionless Systems, LLC’s express prior written permission.
 *
 * The Material may be protected under patent, trademark, copyright, or trade secret laws.  No
 * license is granted to you by disclosure or delivery of the Materials.  Any license must be
 * express and approved by Frictionless Systems, LLC in writing.
 *
 * “Frictionless Systems” and “Impulse” are registered trademarks of Frictionless Systems, LLC.
 */

package systems.frictionless.impulse.browser.composable.component

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import systems.frictionless.impulse.browser.style.AppStyleSheet

@Composable
fun SideNavigation(currentSection: SideNavigationSection) {
    Div(attrs = {
        classes(AppStyleSheet.navigationContainer)
    }) {
        Div(attrs = {
            classes(AppStyleSheet.navigation)
        }) {
            Ol {
                SideNavigationSection.values().forEach { sideNavigationSection ->
                    Li(attrs = {
                        if (sideNavigationSection == currentSection) {
                            classes(AppStyleSheet.selected)
                        }
                    }) {
                        Text(sideNavigationSection.label)
                    }
                }
            }
        }
    }
}

enum class SideNavigationSection(val label: String) {
    Introduction("Introduction"),
    SignIn("Sign In"),
    Demographics("Demographics"),
    Questions("Questions"),
    Insights("Insights")
}
